import { FormControl, FormLabel, Switch, Typography, useTheme, Box, Button } from "@mui/material";
import { colors } from "../../theme/muiColors";
import { useMediaQuery } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { ServiceConfig } from "../services/ServiceConfig";
import { BaseModalComponent } from "./BaseModalComponent";

export const SwitchForm = ({
  title = "Available Services",
  checkedState = [],
  onChangedServicesChange,
  sx,
}) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [localServices, setLocalServices] = useState(checkedState);

  useEffect(() => {
    setLocalServices(checkedState);
    const payload = {
      services: (checkedState || []).map((s) => ({
        id: s.id,
        isActive: s?.companyServices?.[0]?.isActive ?? false,
      })),
    };
    onChangedServicesChange && onChangedServicesChange(payload);
  }, [checkedState, onChangedServicesChange]);

  const baseline = useMemo(() => {
    const m = {};
    checkedState.forEach((s) => {
      m[s.id] = s?.companyServices?.[0]?.isActive ?? false;
    });
    return m;
  }, [checkedState]);

  const isChecked = (item) => item?.companyServices?.[0]?.isActive ?? false;

  const handleToggle = (item, newChecked) => {
    const updated = localServices.map((service) =>
      service.id === item.id
        ? {
            ...service,
            companyServices: [
              { ...(service.companyServices?.[0] || {}), isActive: newChecked },
            ],
          }
        : service
    );
    setLocalServices(updated);

    const payload = {
      services: updated.map((s) => ({
        id: s.id,
        isActive: s?.companyServices?.[0]?.isActive ?? false,
      })),
    };
    onChangedServicesChange && onChangedServicesChange(payload);
  };

  if (!localServices.length) {
    return (
      <Typography
        color="text.secondary"
        sx={{ textAlign: "center", mt: 3, ...sx }}
      >
        No services to display.
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", ...sx }}>
      <FormControl component="fieldset" fullWidth>
        <FormLabel
          component="legend"
          sx={{
            textAlign: "center",
            mb: 3,
            fontWeight: 600,
            fontSize: "1.1rem",
            color: "text.primary",
          }}
        >
          {title}
        </FormLabel>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: isSmall ? "center" : "flex-start",
            maxHeight: { xs: "auto", md: 450 },
            overflowY: "auto",
            pr: 1,
          }}
        >
          {localServices.map((item) => {
            const checked = isChecked(item);
            const label =
              item.workServices?.name ?? item.name ?? `ID ${item.id}`;

            return (
              <Box
                key={item.id}
                sx={{
                  flex: isSmall ? "1 1 100%" : "1 1 45%",
                  minWidth: isSmall ? "100%" : 360,
                  border: "1px solid var(--fx-surface-border, #E2E8F0)",
                  borderRadius: 2,
                  p: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    {label}
                  </Typography>
                  <Switch
                    checked={checked}
                    onChange={(e) => handleToggle(item, e.target.checked)}
                    color="primary"
                  />
                </Box>

                {item?.workTypes?.type === "residencial" && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <BaseModalComponent
                      modalKey={`Service-${item.id}-${item?.workServices?.name}`}
                      modalLabel={`Configure ${item?.workServices?.name}`}
                      elementTrigger={
                        <Button
                          variant="contained"
                          size="medium"
                          disabled={!checked}
                          sx={{
                            px: 3,
                            py: 1,
                            borderRadius: 32,
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "0.9rem",
                            backgroundColor: !checked
                              ? colors.grey[300]
                              : colors.blue[400],
                            "&:hover": {
                              backgroundColor: checked
                                ? colors.blue[600]
                                : colors.grey[300],
                            },
                          }}
                        >
                          Configure
                        </Button>
                      }
                    >
                      <ServiceConfig service={item} />
                    </BaseModalComponent>
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      </FormControl>
    </Box>
  );
};
